/*
 * @Author: wuchenge
 * @Date:   2022-04-07 13:37:33
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-07 15:53:56
 */

import { FooterWrapper } from "./style";

export const Footer = () => {
  return (
    <FooterWrapper>
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >
        鄂ICP备16024732号
      </a>
    </FooterWrapper>
  );
};
